import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SignIn } from "./app/pages/signin/Loadable";
import { ResponsiveOrdersPage } from "app/pages/ResponsiveOrdersPage";
import { ResponsiveRoutesPage } from "app/pages/ResponsiveRoutesPage";
import { RequireAuth } from "app/components/Auth/RequireAuth";
import { GuestOnlyRoute } from "app/components/Auth/GuestOnlyRoute";
import { AppErrorBoundary } from "app/components/Auth/AppErrorBoundary";
import { AppLayout } from "app/components/Layout/AppLayout";

function App() {
  return (
    <AppErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <GuestOnlyRoute>
                <SignIn />
              </GuestOnlyRoute>
            }
          />
          <Route
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="/orders" replace />} />
            <Route path="orders" element={<ResponsiveOrdersPage />} />
            <Route path="routes" element={<ResponsiveRoutesPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppErrorBoundary>
  );
}

export default App;
